import { render } from "./form-part-a-trust-account-details.html?vue&type=template&id=4a86b370&scoped=true&ts=true&external"
import script from "./form-part-a-trust-account-details.ts?vue&type=script&lang=ts&external"
export * from "./form-part-a-trust-account-details.ts?vue&type=script&lang=ts&external"

import "./form-part-a-trust-account-details.scss?vue&type=style&index=0&id=4a86b370&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a86b370"]])

export default __exports__